/**
 * @see https://getbootstrap.com/docs/5.1/components/spinners/
 */

/**
 * Ustawia stan przycisku jako ładowanie
 * @deprecated
 * @param {HTMLElement|jQuery} element
 * @param options
 */
export const setButtonBusyState =  (element, options = {}) => {
    const $el = jQuery(element);
    const $spinner = POLKURIER.getSpinner($el, {size: 'sm', ...options});
    const $icon = $el.find('.fa:first-child, .bi:first-child');
    $icon.hide();
    $icon.after($spinner);
    $el.prop('disabled', true);
};

/**
 * @deprecated
 * Usuwa stan przycisku jako ładowanie
 * @param {HTMLElement|jQuery} element
 */
export const unsetButtonBusyState = (element) => {
    const $el = jQuery(element);
    POLKURIER.removeSpinner($el);
    $el.find('.fa:first-child, .bi:first-child').show();
    $el.prop('disabled', false);
};

/**
 * @deprecated
 * Dodaje dodatkowe metody do spinnera
 * @param $spinner
 * @returns {*}
 */
const decorateSpinner = $spinner => {
    $spinner.toString = () => $spinner.prop('outerHTML');
    return $spinner;
};

/**
 * Zwraca spinner
 * @deprecated
 * @param {string|jQuery|HTMLElement} selector
 * @param {object} options
 * @returns {jQuery}
 */
export const getSpinner = (selector, options = {}) => {
    const $element = jQuery(selector);
    const {show, replace, ...props} = options
    let $spinner = $element.find('.spinner-border');
    if ($spinner.length === 0) {
        $spinner = POLKURIER.createSpinner(props);
    }
    if (show === true) {
        if (replace !== false) {
            $element.empty();
        }
        $element.append($spinner);
    }
    return decorateSpinner($spinner);
};

/**
 * @see https://getbootstrap.com/docs/5.1/components/spinners/
 * Opcje:
 *  {string} size - rozmiar spinnera [''|'sm'] (def '')
 *  {string} color - kolor spinnera [primary|secondary|success|danger|warning|info|light|dark] (def: dark)
 *  {boolean} center - czy wyśrodkowany (def: false)
 * @deprecated
 * @param {object} options
 * @returns {jQuery}
 */
export const createSpinner = (options = {}) => {
    const cssClasses = ['spinner-border', options.class || ''];
    if (options.size) {
        if (typeof options.size === 'number') {
            cssClasses.push(`width-${options.size} height-${options.size}`);
        } else {
            cssClasses.push(`spinner-border-${options.size}`);
        }
    }
    if (options.color) {
        cssClasses.push(`text-${options.color}`);
    }
    if (options.center) {
        cssClasses.push('d-block');
        cssClasses.push('mx-auto');
        cssClasses.push('text-center');
    }
    return decorateSpinner(jQuery('<i>', {class: cssClasses.join(' ')}));
};

/**
 * Dodaje spinner do elementu
 * Opcje:
 *  {boolean} replace - Dodaje do istniejącej treści jeśli TRUE. Usuwa wszystko jeśli FALSE (domyślne zachowanie)
 *  Pozostałe opcje jak w POLKURIER.createSpinner()
 *
 * @deprecated
 * @param {string|jQuery|HTMLElement} selector
 * @param {object} options
 * @returns {jQuery}
 */
export const showSpinner = (selector, options = {}) => {
    const {replace, ...props} = options;
    const $spinner = POLKURIER.createSpinner(props);
    const $element = jQuery(selector);
    if (replace !== false) {
        $element.empty();
    }
    $element.append($spinner);
    return $element;
};

/**
 * Dodaje spinner do elementu
 * @deprecated
 * @param {string|jQuery|HTMLElement} selector
 * @returns {jQuery}
 */
export const removeSpinner = selector => {
    const $element = jQuery(selector);
    const $spinner = $element.find('.spinner-border');
    $spinner.remove();
    return $element;
};
